var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f3060;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #ccc;\n      }\n\n      .cls-4 {\n        fill: #fffffd;\n      }\n\n      .cls-5 {\n        fill: #eaeaea;\n      }\n\n      .cls-6 {\n        fill: #415176;\n      }\n\n      .cls-7 {\n        fill: #9cc9dd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rent"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.32,883.63c-31.02.09-57.57,22.26-63.21,52.76-19.88-9.89-44.01-1.79-53.9,18.09-9.89,19.88-1.79,44.01,18.09,53.9,5.87,2.92,12.37,4.36,18.93,4.19h79.88c35.58-1.44,63.25-31.45,61.81-67.03-1.36-33.56-28.25-60.45-61.81-61.81l.21-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.74,198.5h143.93v232.77h-143.93v-232.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146.74,198.5v33.34h65.63c13.11.01,23.73,10.65,23.72,23.76,0,6.28-2.5,12.31-6.94,16.76l-82.41,82.41v76.5h45.58l98.24-98.24v-134.54h-143.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M868.8,544.92v467.66H146.74v-459.32L511.83,188.16l356.97,356.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M828.8,598.74v353.59c0,11.11-8.94,20.14-20.05,20.26H207.3c-11.19,0-20.26-9.07-20.26-20.26v-345.68c-.17-23.75,9.23-46.56,26.06-63.31l277.72-277.51c11.59-11.66,30.43-11.71,42.08-.13.04.04.08.08.13.13l269.7,269.6c16.8,16.77,26.18,39.57,26.06,63.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M186.73,569.82L511.83,244.83l-325.1,325.21v-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M828.8,561.49v.21L511.83,244.83l316.98,316.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M677.18,500.08h-330.59c-8.86,0-16.04-7.18-16.04-16.03,0-4.28,1.71-8.39,4.75-11.4l165.24-165.24c6.29-6.21,16.4-6.21,22.69,0l165.35,165.24c6.29,6.23,6.34,16.39.11,22.68-3.04,3.07-7.19,4.78-11.51,4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M542.75,383.48l-24.69-24.69c-3.38-3.38-8.86-3.38-12.24,0,0,0,0,0,0,0l-24.16,24.69c-3.34,3.5-3.21,9.04.29,12.38,1.44,1.38,3.31,2.22,5.3,2.39h49.28c4.84-.08,8.69-4.06,8.62-8.9-.03-2.19-.89-4.29-2.39-5.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M963.76,560.43l-18.57,18.57c-11.68,11.59-30.52,11.59-42.21,0l-390.42-390.94L122.15,579c-11.68,11.59-30.52,11.59-42.21,0l-20.37-18.57c-11.53-11.71-11.53-30.5,0-42.21L489.14,88.87c12.13-12.59,32.17-12.96,44.76-.82.28.27.55.54.82.82l38.2,38.2,390.42,390.42c11.97,11.43,12.42,30.4.99,42.37-.19.2-.37.39-.57.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M971.99,533.21c1.05,6.32-3.23,12.3-9.56,13.35-3.78.63-7.63-.66-10.28-3.43-76.08-76.4-430.3-430.51-432.62-432.62-4.52-4.3-11.62-4.3-16.14,0-2,2-356.44,356.33-432.1,432.62-4.54,4.61-11.96,4.66-16.56.11-2.63-2.59-3.88-6.27-3.38-9.93,1.1-5.83,3.97-11.17,8.23-15.3L489.14,88.87c12.13-12.59,32.17-12.96,44.76-.82.28.27.55.54.82.82l38.2,38.2,390.94,390.94c4.18,4.13,7.02,9.42,8.12,15.19h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M541.8,660.99h250.71v351.69h-250.71v-351.69Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 571.87,
    y: 710.58,
    width: 190.57,
    height: 272.03,
    rx: 10.76,
    ry: 10.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M607.64,740.66h118.92c3.2,0,5.8,2.6,5.8,5.8v29.02c0,3.2-2.6,5.8-5.8,5.8h-118.92c-3.2,0-5.8-2.6-5.8-5.8v-29.02c0-3.2,2.6-5.8,5.8-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M541.8,660.99h250.71v26.91h-250.71v-26.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M473.74,660.89v169.99c0,7.75-6.28,14.03-14.03,14.03h-222.64c-7.71-.06-13.93-6.32-13.93-14.03v-169.99h250.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 243.07,
    y: 676.61,
    width: 210.61,
    height: 152.58,
    rx: 10.66,
    ry: 10.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M564.48,607.28h205.34c12.53,0,22.69,10.15,22.69,22.68,0,.14,0,.28,0,.43v30.6h-250.71v-30.6c-.23-12.53,9.73-22.87,22.26-23.1.14,0,.28,0,.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M582.31,624.48h169.78c5.83,0,10.55,4.72,10.55,10.55v25.96h-190.78v-26.17c.11-5.7,4.74-10.28,10.45-10.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M245.71,607.28h205.34c12.53,0,22.69,10.15,22.69,22.68,0,.14,0,.28,0,.43v30.6h-250.71v-30.6c-.23-12.53,9.73-22.87,22.26-23.1.14,0,.28,0,.43,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.44,624.48h169.78c5.83,0,10.55,4.72,10.55,10.55v25.96h-190.78v-26.17c.11-5.7,4.74-10.28,10.45-10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.15,660.89h20.47v184.02h-20.47v-184.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.15,676.61h20.47v152.58h-20.47v-152.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M338.15,734.54h20.47v36.83h-20.47v-36.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.13,742.77h250.61v20.47h-250.61v-20.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.91,742.77h212.83v20.47h-212.83v-20.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M329.91,742.77h36.83c5.65,0,10.24,4.58,10.24,10.24h0c0,5.65-4.58,10.24-10.24,10.24h-36.83c-5.65,0-10.24-4.58-10.24-10.24h0c0-5.65,4.58-10.24,10.24-10.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 606.58,
    cy: 836.78,
    r: 20.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 117.51,
    y: 129.28,
    width: 202.28,
    height: 69.01,
    rx: 19.2,
    ry: 19.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 165.31,
    y: 129.28,
    width: 106.68,
    height: 69.01,
    rx: 19.2,
    ry: 19.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M389.64,906.53h-82.52c-5.65,1.42-11.38-2.02-12.8-7.67-1.42-5.65,2.02-11.38,7.67-12.8,1.68-.42,3.45-.42,5.13,0h82.52c5.65,1.42,9.09,7.15,7.67,12.8-.95,3.78-3.89,6.72-7.67,7.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M843.37,823.28h62.99v189.3h-62.99v-189.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M843.37,823.28h62.99v88h-62.99v-88Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 687.83,
    y: 660.99,
    width: 374.17,
    height: 219.48,
    rx: 20.05,
    ry: 20.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 730.04,
    y: 703.2,
    width: 289.75,
    height: 135.06,
    rx: 5.28,
    ry: 5.28
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M766.55,773.68h-24.06c-5.83,0-10.55-4.72-10.55-10.55v-36.72c0-5.83,4.72-10.55,10.55-10.55h24.06c16.03,0,29.02,12.99,29.02,29.02s-12.99,29.02-29.02,29.02v-.21ZM753.04,752.58h13.51c4.2,0,7.6-3.4,7.6-7.6s-3.4-7.6-7.6-7.6h-13.4l-.11,15.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M742.49,825.7c-5.83,0-10.55-4.72-10.55-10.55v-52.23c0-5.83,4.72-10.55,10.55-10.55s10.55,4.72,10.55,10.55v52.02c.12,5.83-4.51,10.64-10.34,10.76-.07,0-.14,0-.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M795.25,825.7c-3.93.03-7.55-2.13-9.39-5.59l-28.6-52.02c-2.91-5.19-1.07-11.75,4.12-14.67,5.19-2.91,11.75-1.07,14.67,4.12l28.6,52.23c2.94,5.03,1.24,11.49-3.8,14.43-.14.08-.28.16-.43.24-1.6.83-3.37,1.26-5.17,1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M857.29,825.7h-32.5c-5.83,0-10.55-4.72-10.55-10.55v-88.74c0-5.83,4.72-10.55,10.55-10.55h32.5c5.83,0,10.55,4.72,10.55,10.55s-4.72,10.55-10.55,10.55h-21.74v67.22h21.74c5.83,0,10.55,4.72,10.55,10.55s-4.72,10.55-10.55,10.55v.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M843.79,781.39h-18.99c-5.83,0-10.55-4.72-10.55-10.55s4.72-10.55,10.55-10.55h18.99c5.83,0,10.55,4.72,10.55,10.55s-4.72,10.55-10.55,10.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M935.38,825.7c-4.07.05-7.81-2.25-9.6-5.91l-23.43-47.48v42.21c0,5.83-4.72,10.55-10.55,10.55s-10.55-4.72-10.55-10.55v-88.11c-.12-5.03,3.32-9.45,8.23-10.55,4.89-1.24,9.97,1.14,12.13,5.7l23.21,47.48v-42.21c0-5.83,4.72-10.55,10.55-10.55s10.55,4.72,10.55,10.55v88.53c.11,5.06-3.39,9.49-8.34,10.55-.74.02-1.49-.05-2.22-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1007.34,737.07h-46.11c-5.83,0-10.55-4.72-10.55-10.55s4.72-10.55,10.55-10.55h46.11c5.83,0,10.55,4.72,10.55,10.55s-4.72,10.55-10.55,10.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M984.23,825.7c-5.83,0-10.55-4.72-10.55-10.55v-88.74c0-5.83,4.72-10.55,10.55-10.55s10.55,4.72,10.55,10.55v88.53c.12,5.83-4.51,10.64-10.34,10.76-.07,0-.14,0-.21,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.fb8ea922ba310421e817a27d2f93dbee.svg";
export { ForwardRef as ReactComponent };